import React from 'react';
import pluralize from 'pluralize';
import CourseImage from '../../../../../Image/components/CourseImage';
import DotList from '../../../../../Structure/DotList';
import ViewerErrorBoundary from '../../ViewerConclusion/ViewerErrorBoundary';
import { ViewerHeaderContainer, ViewerHeaderType, ViewerHeaderAttributesContainer, ViewerHeaderImageContainer, StyledTypography } from '../ViewerHeader.styles';
export const COURSE_TYPE_TEXT = 'Course';
const CourseViewerHeader = ({ skillImages, uncroppedImage, title, author, skillLength }) => {
    const renderAuthor = () => {
        if (author) {
            return author;
        }
        return null;
    };
    const renderSkillLength = () => {
        if (skillLength) {
            return pluralize('skill', skillLength, true);
        }
        return null;
    };
    return (React.createElement(ViewerErrorBoundary, null,
        React.createElement(ViewerHeaderContainer, null,
            React.createElement(ViewerHeaderImageContainer, null,
                React.createElement(CourseImage.Large, { skillImages: skillImages, image: uncroppedImage })),
            React.createElement(ViewerHeaderAttributesContainer, null,
                React.createElement(ViewerHeaderType, null, COURSE_TYPE_TEXT),
                React.createElement(StyledTypography, { variant: "h5" }, title),
                React.createElement(DotList, null,
                    renderAuthor(),
                    renderSkillLength())))));
};
export default CourseViewerHeader;
//# sourceMappingURL=index.js.map